<div class="upload_photos">
    <div class="container">
        <div class="dropzone-wrapper" [class.disabled]="imagePreviews.length == 5" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
            (click)="imagePreviews.length < 5 && fileInput.click()">
            <div class="dropzone-desc">
                <p>Choose an image file or drag it here.</p>
            </div>
            <input type="file" (change)="onFileSelected($event)" accept="image/*" multiple #fileInput hidden />
        </div>
        <div class="error-parent">
            <div *ngIf="imagePreviews.length>4" class="error-message">Maximum 5 files allowed.</div>
            <div *ngIf="formateErrror" class="error-message">Only image files are allowed.</div>
        </div>
    </div>
    <div class="preview_imgs_flex">
        <div class="preview_img" *ngFor="let img of imagePreviews; let i = index">
            <span class="close_icon" (click)="removeImg(i)"><img [src]="this.api.frontendAssetsUrl + 'close.svg'" alt=""></span>
            <img [src]="img.url">
        </div>
    </div>
    <div class="col-lg-7" *ngIf="imagePreviews.length > 0">
        <button (click)="uploadFiles()" class="btn btn-primary start" [disabled]="!showText">
            <div *ngIf="showText">
                <fa-icon [icon]="faUpload"></fa-icon>
                <span>Start upload</span>
            </div>
            <div *ngIf="!showText">
                <mat-spinner></mat-spinner>
            </div>
        </button>
        <button class="btn btn-warning cancel" (click)="removeAll()" [disabled]="!showText">
            <fa-icon [icon]="faBan"></fa-icon>
            <span>Cancel upload</span>
        </button>
        <span class="fileupload-process"></span>
    </div>
</div>